import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnDestroy, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CountriesMask } from "src/app/variables/countries-phones";
import { ChatService } from 'src/app/services/chat.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-modal-msg-start-chat-whatsapp',
  templateUrl: './modal-msg-start-chat-whatsapp.component.html',
  styleUrls: ['./modal-msg-start-chat-whatsapp.component.scss']
})
export class ModalMsgStartChatWhatsappComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('selectPadrao') selectPadrao: any;
  @Input() data;
  @Input() templateMessage: boolean;
  @Input() isToShowSpecificMessageFromMeta: boolean;
  @Input() isErro131047: boolean = false;
  @Input() mensagemErro: any;
  @Input() contatoSelecionado: any;
  content: any;
  template_content: any;
  template_header: any;
  template_footer: any;
  newSubs: Subscription;
  providerId!: number;
  integrationId!: number;
  integracaoId: any;
  disabledDropDown: boolean = false;

  provedorSelecionado: any;
  numeroSaida: any;
  integracoes: any = [];
  chamadoId: Number;
  chamadoCodigo: number;
  chamadoAssunto: string;
  templatesZapfy: any;

  constructor(
    private modal: NgbActiveModal,
    private whatsappService: WhatsappService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private chatService: ChatService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.provedorSelecionado = null;
    this.providerId = null;
    this.integrationId = null;
    this.integracoes = [];
  }

  ngOnInit(): void {
    if (this.data) {
      this.chamadoId = this.data.chamadoId;
      this.chamadoCodigo = this.data.chamado_codigo;
      this.chamadoAssunto = this.data.chamado_assunto;
    }
    
    this.constructData();
    this.carregarIntegracoes();
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }
  
  ngAfterViewInit(): void {
  }

  close(result?): void {
    if (result) {
      this.provedorSelecionado = {...this.provedorSelecionado, ...result};
      this.provedorSelecionado.chamado_id = this.chamadoId;
      this.provedorSelecionado.chamado_codigo = this.chamadoCodigo;
      this.provedorSelecionado.chamado_assunto = this.chamadoAssunto;
      this.modal.close(this.provedorSelecionado);
    } else {
      this.modal.close(false);
    }
  }

  verifyMetaTemplates(integration_id): void {
    this.newSubs = this.whatsappService.wppOfficialGetTemplates(integration_id)
      .subscribe({
        next: (results) => {
          if(!results?.lista?.length) {
            Swal.fire({
              text: this.translate.instant('ALERTA_SEM_TEMPLATE_META'),
              icon: 'warning',
              confirmButtonText: 'Ok'
            });
            this.modal.close();
          }
        }, error: (error) => {
          Swal.fire({
            text: this.translate.instant('ALERTA_SEM_TEMPLATE_META'),
            icon: 'warning',
            confirmButtonText: 'Ok'
          });
          this.modal.close();
        }
      });
  }

  constructData(): void {
    this.content = {
      numero_contato: null,
      chamado_id: null,
      mensagem: null,
      nome_contato: null,
      contato_id: null,
      cliente_id: null,
      from: null,
      numero_destino: null,
      template_name: null,
      language: null
    };
  }

  changeTemplateProperties(properties): void {
    if(properties?.status === "Bloqueado(Config. Variável)" || properties?.status === "Bloqueado") {
      Swal.fire({
        text: this.translate.instant('ALERTA_TEMPLATE_BLOQUEADO'),
        icon: 'warning',
        confirmButtonText: 'Ok',
        position: 'top'
      });
      return
    }

    if(properties) {

      // MIL-29803: ao iniciar uma conversa (template META), o chat/protocolo ainda não existe
      // neste momento - só é criado depois, no backend. Por isso, em vez de gravar "Não Possui"
      // (que ia parar definitivamente na mensagem/parâmetros enviados ao WhatsApp), usamos um
      // marcador sentinela que o backend substitui pelo protocolo real assim que o chat é criado
      // (ver chatService.iniciarConversaWhatsappChat). Os demais marcadores (Ticket/Assunto)
      // continuam podendo ser legitimamente "Não Possui" (ex.: conversa sem chamado vinculado).
      const PROTOCOLO_SENTINEL = "PROTOCOLO_CHAT_PENDENTE";

      const marcadores = [
        { chave: '{{Contato}}', valor: this.data.contato },
        { chave: '{{Empresa}}', valor: this.data.empresa },
        { chave: '{{Operador}}', valor: this.data.operador },
        { chave: '{{Ticket}}', valor: this.data.chamado_codigo || "Não Possui" },
        { chave: '{{Protocolo}}', valor: this.data.protocolo || PROTOCOLO_SENTINEL },
        { chave: '{{Assunto}}', valor: this.data.chamado_assunto || "Não Possui" },
        { chave: '{{contato}}', valor: this.data.contato },
        { chave: '{{empresa}}', valor: this.data.empresa },
        { chave: '{{operador}}', valor: this.data.operador },
        { chave: '{{ticket}}', valor: this.data.chamado_codigo || "Não Possui" },
        { chave: '{{protocolo}}', valor: this.data.protocolo || PROTOCOLO_SENTINEL },
        { chave: '{{assunto}}', valor: this.data.chamado_assunto || "Não Possui" }
      ];


      const substituirMarcadores = (texto: string) =>
        marcadores.reduce((acc, m) => acc?.replaceAll(m.chave, m.valor), texto);

      const variaveisContent = marcadores
        .filter(m => properties?.content?.includes(m.chave))
        .map(m => m.valor);

      const variaveisHeader = marcadores
        .filter(m => properties?.header?.includes(m.chave))
        .map(m => m.valor);

      const variaveisDescricaoOriginal = marcadores
        .filter(m => properties?.descricao_original?.includes(m.chave))
        .map(m => m.chave?.replace(/[{}]/g, ''));

      const variaveisHeaderOriginal = marcadores
        .filter(m => properties?.header_original?.includes(m.chave))
        .map(m => m.chave?.replace(/[{}]/g, ''));

      const templateContent = substituirMarcadores(properties.content);
      const templateHeader = substituirMarcadores(properties.header);

      this.content = {
        template_name: properties.title,
        language: properties.lang,
        template_content: templateContent,
        header: templateHeader,
        footer: properties.footer,
        variaveis_content: variaveisContent,
        variaveis_header: variaveisHeader,
        variaveis_descricao_original: variaveisDescricaoOriginal,
        variaveis_header_original: variaveisHeaderOriginal
      };
      // A prévia usa a macro legível; o payload mantém o marcador para o backend.
      this.template_content = templateContent?.replaceAll(PROTOCOLO_SENTINEL, '{{Protocolo}}');
      this.template_header = templateHeader?.replaceAll(PROTOCOLO_SENTINEL, '{{Protocolo}}');
      this.template_footer = properties.footer;
    } else {
      this.content = {
        template_name: null,
        language: null,
      };
      this.template_content = null;
    }
  }

  changeTemplatePropertiesZapfy(event) {
    this.content.mensagem = event.id
  }

  verifyDisabled(): boolean {
    if(this.integracoes && this.integracoes.length === 1) {
      return false;
    }

    if(this.providerId === 4) {
      return !this.content.template_name && !this.content.language;
    } else if (this.providerId === 2 || this.providerId === 7) {
      return !this.content.mensagem;
    }
    return true;
  }

  getMaskByCountry(number: string | number): string {
    if (!number) {
      return '';
    }
  
    return CountriesMask(number.toString().length, number.toString());
  }

  formatPhoneNumber(phone: string): string {
    const phoneLength = phone.length;
  
    if (phoneLength > 10 && phone.includes('0800')) {
      return `${phone.slice(0, 4)} ${phone.slice(4, 7)} ${phone.slice(7, 11)}`;
    }
  
    switch (phoneLength) {
      case 4:
        return `${phone}`;
      case 5:
        return `${phone}`;
      case 6:
        return `${phone.slice(0, 3)} ${phone.slice(3, 6)}`;
      case 7:
        return `${phone.slice(0, 3)} ${phone.slice(3, 7)}`;
      case 8:
        return `${phone.slice(0, 4)} ${phone.slice(4, 8)}`;
      case 9:
        return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 9)}`;
      case 10:
        return `(${phone.slice(0, 2)}) ${phone.slice(2, 6)} ${phone.slice(6, 10)}`;
      case 11:
        return `(${phone.slice(0, 2)})${phone.slice(2, 3)} ${phone.slice(3, 7)}-${phone.slice(7, 11)}`;
      case 12:
        return `${phone.slice(0, 4)} ${phone.slice(4, 8)} ${phone.slice(8, 12)}`;
      case 13:
        return `${phone.slice(0, 4)} ${phone.slice(4, 8)} ${phone.slice(8, 13)}`;
      default:
        return phone;
    }
  }

  resetarEstado(): void {
    this.provedorSelecionado = null;
    this.providerId = null;
    this.integrationId = null;
    this.template_content = null;
    this.disabledDropDown = false;
  }



  carregarIntegracoes(): void {
    this.whatsappService.obterIntegracao().subscribe({
      next: (integracoes: any[]) => {
        if (integracoes && integracoes.length > 0) {
          this.integracoes = integracoes.map(integracao => {
            return {
              ...integracao,
              id: integracao.id,
              integracao_id: integracao.integracao_id,
              nome: integracao.nome_fila || integracao.nome,
              text: `${integracao.nome_fila || integracao.nome} - ${this.formatarNumero(integracao.numero)}`
            };
          });
          
          this.identificarFilaChat();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar integrações:', error);
      }
    });
  }

  identificarFilaChat(): void {
    if (this.integracoes.length === 1) {
      this.escolhaSaida(this.integracoes[0]);
      return;
    }

    if (this.data?.fila_atendimento?.id) {
      const integracaoEspecifica = this.integracoes.find(integracao => {
        const nomeCoincide = (integracao.nome_fila || integracao.nome) === this.data.fila_atendimento.descricao;
        const numeroCoincide = integracao.numero === this.contatoSelecionado?.numero_empresa;
        return nomeCoincide && numeroCoincide;
      });
      
      if (integracaoEspecifica) {
        this.escolhaSaida(integracaoEspecifica);
        this.atualizarSelectVisual(integracaoEspecifica);
        return;
      }
    }

    if (this.data?.provider_id) {
      const integracoesMesmoProvider = this.integracoes.filter(integracao => 
        integracao.provider_id === this.data.provider_id
      );
      
      if (integracoesMesmoProvider.length === 1) {
        this.escolhaSaida(integracoesMesmoProvider[0]);
        this.atualizarSelectVisual(integracoesMesmoProvider[0]);
      } else if (integracoesMesmoProvider.length > 1) {
        const filaSalvaId = localStorage.getItem(`whatsapp_fila_${this.data.chat_id}`);
        
        if (filaSalvaId) {
          const filaSalva = integracoesMesmoProvider.find(integracao => 
            integracao.integracao_id == filaSalvaId || integracao.id == filaSalvaId
          );
          
          if (filaSalva) {
            this.escolhaSaida(filaSalva);
            this.atualizarSelectVisual(filaSalva);
          }
        }
      }
    }
  }

  atualizarSelectVisual(integracao: any): void {
    setTimeout(() => {
      if (this.selectPadrao && this.selectPadrao.ctrl) {
        this.selectPadrao.ctrl.selectedValue = integracao;
        this.selectPadrao.ctrl.modelValue = integracao;
        this.cdr.detectChanges();
      }
    }, 300);
  }

  escolhaSaida(event: any): void {
    if (!event) return;
    
    this.provedorSelecionado = event;
    this.providerId = event.provider_id;
    this.integrationId = event.integracao_id;
    
    if (this.data?.chat_id) {
      localStorage.setItem(`whatsapp_fila_${this.data.chat_id}`, event.integracao_id.toString());
    }
    
    this.cdr.detectChanges();
    
    if (this.chamadoId && (this.providerId === 2 || this.providerId === 7)) {
      this.content.mensagem = event.mensagem_inicial_com_ticket_conciliado;
    } else if (!this.chamadoId && (this.providerId === 2 || this.providerId === 7)) {
      this.content.mensagem = event.mensagem_inicial_sem_ticket_conciliado;
    }
    
    if (this.providerId === 4) {
      this.verifyMetaTemplates(this.integrationId);
    }
  }

  retornoSelectIntegracoes(event: any): void {
    this.integracoes = event;
    
    if (!this.provedorSelecionado) {
      this.identificarFilaChat();
    }
  }

  retornoSelectTemplatesMeta(event) {
    if (event.length === 1 && this.providerId === 4) {
      this.content = {
        template_name: event[0].name,
        language: event[0].language,
        template_content: event[0].bodyText
      };
      this.content.mensagem = event[0].bodyText;
      this.template_content = event[0].bodyText;
      this.disabledDropDown = true;
    }
  }
  
  formatarNumero(numero: string): string {
    if (!numero) return '';
    
    const numLimpo = numero.replace(/\D/g, '');
    
    if (numLimpo.length === 11) {
      return `(${numLimpo.substring(0, 2)}) ${numLimpo.substring(2, 7)}-${numLimpo.substring(7)}`;
    } else if (numLimpo.length === 10) {
      return `(${numLimpo.substring(0, 2)}) ${numLimpo.substring(2, 6)}-${numLimpo.substring(6)}`;
    } else {
      return numero;
    }
  }
}
